/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Deck_Building_TitleInputs */



/**
* | output |
* | --- |
* | "Building Decks" |
*
* @param {Help_Article_Deck_Building_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_deck_building_title = /** @type {((inputs?: Help_Article_Deck_Building_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Deck_Building_TitleInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Decks bauen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Construire des decks")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("构筑卡组")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("建構牌組")
	if (locale === "ko") return /** @type {LocalizedString} */ ("덱 만들기")
	return /** @type {LocalizedString} */ ("Building Decks")
});